












import Vue from 'vue' // eslint-disable-line no-unused-vars

export default {
  name: 'app-market-update-modal',
  components: {
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  methods: {
    openStore() {
      let url
      if (window.device.platform === 'Android') {
        url = `market://details?id=com.meteo_parapente`
      } else if (window.device.platform === 'iOS') {
        url = `itms-apps://itunes.apple.com/app/id1255974302`
      } else {
        throw Error(`Unknown platform: ${window.device.platform}`)
      }
      window.open(url, '_system')
    }
  },
  computed: {
    versions() {
      return this.$store.state.time.needAppMarketUpdate
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/app-market-update.vue